export default __webpack_public_path__ + "static/media/h_top-2.553a4dc6.svg";